import { Stack, styled } from '@mui/material';

export const SecurityInfoContainer = styled(Stack)(({ theme }) => ({
  marginTop: 'auto',
  paddingTop: theme.spacing(6),
  alignItems: 'center',
  justifyContent: 'center',
  gap: theme.spacing(1),
  color: theme.palette.grey[500],
  '& .MuiTypography-root': {
    fontSize: '0.875rem',
  },
}));
